/** @param {string} raw */
export function normalizeCardDigits(raw) {
  return String(raw || "").replace(/\D/g, "");
}

/** @param {string} digits */
export function passesLuhn(digits) {
  if (!digits || !/^\d+$/.test(digits)) {
    return false;
  }
  let sum = 0;
  let alt = false;
  for (let i = digits.length - 1; i >= 0; i -= 1) {
    let n = parseInt(digits[i], 10);
    if (alt) {
      n *= 2;
      if (n > 9) {
        n -= 9;
      }
    }
    sum += n;
    alt = !alt;
  }
  return sum % 10 === 0;
}

/**
 * card is valid until the end of the month.
 * @param {string} month two digits
 * @param {string} year two or four digits
 */
export function isCardExpiryValid(month, year) {
  const m = parseInt(String(month).replace(/\D/g, ""), 10);
  if (Number.isNaN(m) || m < 1 || m > 12) {
    return false;
  }
  const yRaw = String(year).replace(/\D/g, "");
  if (!yRaw) {
    return false;
  }
  const y = yRaw.length === 2 ? 2000 + parseInt(yRaw, 10) : parseInt(yRaw, 10);
  if (Number.isNaN(y) || y < 2000 || y > 2100) {
    return false;
  }
  const expYm = y * 12 + m;
  const now = new Date();
  const curYm = now.getFullYear() * 12 + (now.getMonth() + 1);
  return expYm >= curYm;
}

/**
 * before saving card in param.
 * @returns {'invalid_card_number'|'invalid_card_luhn'|'invalid_card_expiry'|null}
 */
export function validateCardForStore(form) {
  const digits = normalizeCardDigits(form.card_number);
  if (digits.length < 13 || digits.length > 19) {
    return "invalid_card_number";
  }
  if (!passesLuhn(digits)) {
    return "invalid_card_luhn";
  }
  if (!isCardExpiryValid(form.exp_month, form.exp_year)) {
    return "invalid_card_expiry";
  }
  return null;
}

/** @param {*} err axios error response */
export function paymentMethodAddErrorMessage(err, t) {
  const code = err.response?.data?.error;
  if (code === "iyzipay_email_required") {
    return t("iyzipayEmailRequired");
  }
  if (code && typeof code === "string") {
    const key = `paramPayCardError_${code}`;
    const localized = t(key, { defaultValue: "" });
    if (localized && localized !== key) {
      return localized;
    }
  }
  const msg = err.response?.data?.message;
  if (msg && typeof msg === "string") {
    return msg;
  }
  return t("paramPayCardAddFailed");
}
